module.exports = __webpack_public_path__ + "static/media/asu_logo.272679bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/asu_logo.png
// module id = 509
// module chunks = 0